import type { CardTemplate } from '@nudge/shared';

export const FAVORITES_CATEGORY = 'favorites';

/**
 * Groups non-archived CardTemplates by category key, with each group sorted
 * ascending by sort_order. Archived templates are excluded.
 *
 * Favourites are surfaced as a synthetic 'favorites' category at the top of
 * the returned Map (insertion order is preserved). Favourited templates also
 * still appear under their real category.
 *
 * @param templates - Full flat list of templates from the store
 * @returns Map keyed by category string, values are sorted template arrays
 */
export function groupTemplatesByCategory(templates: CardTemplate[]): Map<string, CardTemplate[]> {
  const map = new Map<string, CardTemplate[]>();
  const favorites = templates
    .filter((t) => !t.archived && t.is_favorite)
    .sort((a, b) => a.sort_order - b.sort_order);
  if (favorites.length > 0) map.set(FAVORITES_CATEGORY, favorites);
  for (const t of templates) {
    if (t.archived) continue;
    const arr = map.get(t.category) ?? [];
    arr.push(t);
    map.set(t.category, arr);
  }
  for (const [key, arr] of map.entries()) {
    if (key === FAVORITES_CATEGORY) continue;
    arr.sort((a, b) => a.sort_order - b.sort_order);
  }
  return map;
}
